import { defineMessages } from 'react-intl';

export default defineMessages({
  appVersion: 'Wersja aplikacji:',
  apiVersion: 'Wersja API:',
});
